import { Menu, Tooltip } from '@mantine/core'
import { IconCircleCheck } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import type { EstadoDeInicioDeAtendimento } from '@/pages/chat/atendimentoChamado'
import type { ChamadoParaAtendimentoIa } from './IniciarAtendimentoIaButton'

/** Por que o item está desabilitado, ou `null` se pode finalizar (spec 2026-10-16 §4.4). */
export function motivoDoFinalizarDesabilitado(c: ChamadoParaAtendimentoIa): string | null {
  if (c.status !== 'in_progress') return 'Inicie o atendimento antes de finalizar'
  const vivo = c.atendimento_ia?.pedidos_em_andamento?.[0]
  if (vivo) return `O pedido #${vivo.id} está em ${vivo.estado}`
  return null
}

/**
 * Item "Finalizar chamado com IA" do menu do atendimento. Pede ao @Atendente que redija o
 * fechamento; quem finaliza é o atendente, no cartão da conversa. Esconder é conveniência:
 * a rota de apply barra (403/409). Vai dentro de `Menu.Dropdown` (prop `acoes` do botão).
 */
export function FinalizarComIaItem({ chamado }: { chamado: ChamadoParaAtendimentoIa }) {
  const navigate = useNavigate()
  const motivo = motivoDoFinalizarDesabilitado(chamado)
  const conversa = chamado.atendimento_ia?.conversation_id

  function finalizar() {
    if (motivo || conversa == null) return
    const estado: EstadoDeInicioDeAtendimento = {
      finalizarChamado: {
        chamadoId: chamado.id,
        protocolo: chamado.protocol_number ?? `#${chamado.id}`,
      },
    }
    navigate(`/chat/${conversa}`, { state: estado })
  }

  return (
    <Tooltip label={motivo ?? ''} disabled={motivo === null} withArrow position="left">
      <div>
        <Menu.Item
          leftSection={<IconCircleCheck size={14} stroke={1.75} />}
          disabled={motivo !== null || conversa == null}
          onClick={finalizar}
        >
          Finalizar chamado com IA
        </Menu.Item>
      </div>
    </Tooltip>
  )
}
